function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.273 18.038a6.08 6.08 0 11-12.162 0 6.08 6.08 0 1112.162 0z",
  strokeWidth: 1.00031792
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.151
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.849 17.517c1.737-2.606 3.475 0 3.475 0M31.536 17.517c-1.738-2.606-3.475 0-3.475 0",
  strokeWidth: 0.99988521
})), /*#__PURE__*/React.createElement("path", {
  d: "M31.375 25.856c-1.898-2.045-6.42-1.995-8.37 0C17 32 16.332 54.08 16.332 54.08c4.948 1.436 15.788 1.737 21.718 0 0 0-.051-21.08-6.676-28.224z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 9.5a7.5 2.5 0 11-15 0 7.5 2.5 0 1115 0z",
  transform: "matrix(.8687 0 0 .52122 27.54 3.965)",
  strokeWidth: 1.486,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.546 26.725c-1.738 4.344-2.863 6.95-3.554 10.425-.182.914-3.908 4.912-4.837 6.08-3.455 4.344-2.877-.599-3.455 0-6.24 6.464-1.985-1.792-3.455-.868-1.382.869-1.382 2.606-4.838 3.475-2.71.681 1.383-2.606 2.765-13.9.87-7.113 3.867-13.899 8.637-13.899 2.338 0 3.895.526 5.262 1.737 1.422 1.262 3.475 3.475 3.475 6.95zM32.99 26.725c1.737 4.344 2.863 6.95 3.554 10.425.182.914 3.907 4.912 4.837 6.08 3.455 4.344 2.877-.599 3.455 0 6.24 6.464 1.985-1.792 3.455-.868 1.382.869 1.382 2.606 4.837 3.475 2.71.681-1.382-2.606-2.764-13.9-.87-7.113-3.867-13.899-8.638-13.899-2.337 0-3.895.526-5.261 1.737-1.422 1.262-3.475 3.475-3.475 6.95z",
  strokeLinejoin: "round"
}));

var SvgAngel = function SvgAngel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAngel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Angel.5b4ad6bc.svg";
export { ForwardRef as ReactComponent };